export const ExportCreationSource = Object.freeze({
  ANDROID: {
    value: 1,
    name: 'Android',
    readableName: 'Android App',
  },
  IOS: {
    value: 2,
    name: 'iOS',
    readableName: 'iOS App',
  },
  DASHBOARD: {
    value: 3,
    name: 'Dashboard',
    readableName: 'Omnistream Dashboard',
  },
  CONTROLLER: {
    value: 4,
    name: 'Controller',
    readableName: 'Omnistream Controller',
  },
});

export const EXPORT_CREATION_SOURCE = Object.freeze({
  ANDROID: 1,
  IOS: 2,
  DASHBOARD: 3,
  CONTROLLER: 4,
});

export const getExportCreationSourceFromValue = (value) => {
  if (value == null) return null;
  const numericVal = Number(value);
  for (const key of Object.keys(ExportCreationSource)) {
    if (ExportCreationSource[key].value === numericVal) {
      return ExportCreationSource[key];
    }
  }
  return null;
};
